import { promoteInlineStyles, relocateInlineStylesInHtml } from './promoteInlineStyles'
import { injectProductLinkCards, enhanceHotspotDeviceCards } from '@/components/shared/utils/productLinkCards'
import { bindPortalProductDeviceLinks } from '@/components/shared/utils/portalProductNavigation'
import { bindPortalAttachmentLinks } from '@/components/shared/utils/openPdfBlob'
import {
  bindStaticHotspotTabs,
  initHotspotDeviceCarousels,
} from '@/components/shared/utils/hotspotTabs'
import {
  bindHotspotAnchorLinks,
  scrollToHotspotHash,
} from '@/components/shared/utils/hotspotAnchor'
import { bindStaticTableTabs } from '@/components/shared/utils/tableTabs'
import { syncRichContentUiLabels } from '@/components/shared/utils/richContentUiLabels'

const enhanceSeqMap = new WeakMap()
let hotspotHashListenerBound = false

function ensureHotspotHashListener() {
  if (hotspotHashListenerBound || typeof window === 'undefined') return
  hotspotHashListenerBound = true
  window.addEventListener('hashchange', () => {
    scrollToHotspotHash(document, { behavior: 'smooth' })
  })
}

function scheduleScrollToHotspotHash(root) {
  if (typeof window === 'undefined') return
  ensureHotspotHashListener()
  const run = () => scrollToHotspotHash(root || document, { behavior: 'auto' })
  requestAnimationFrame(() => {
    run()
    window.setTimeout(run, 80)
    window.setTimeout(run, 320)
  })
}

/** 确保产品索引与分类已加载，便于解析设备链接卡片 */
async function ensureProductLookups(store) {
  if (!store?.dispatch) return
  const tasks = []
  if (!store.state?.productCategories?.loaded) {
    tasks.push(store.dispatch('productCategories/fetchCategories').catch(() => {}))
  }
  if (!(store.getters?.['products/allItems'] || []).length) {
    tasks.push(store.dispatch('products/fetchProductsByCategory', '').catch(() => {}))
  }
  if (tasks.length) await Promise.all(tasks)
}

/** 写入 HTML 后注入设备链接小卡片 */
async function applyHtml(el, html, instance) {
  const store = instance?.$store
  syncRichContentUiLabels(store?.state?.locale?.current)

  el.innerHTML = relocateInlineStylesInHtml(html || '')
  promoteInlineStyles(el)
  bindStaticHotspotTabs()
  bindStaticTableTabs()
  initHotspotDeviceCarousels(el)
  bindHotspotAnchorLinks(el)
  scheduleScrollToHotspotHash(el)

  bindPortalProductDeviceLinks(el, instance)
  bindPortalAttachmentLinks(el)

  if (!store) return

  const seq = (enhanceSeqMap.get(el) || 0) + 1
  enhanceSeqMap.set(el, seq)

  await ensureProductLookups(store)
  if (enhanceSeqMap.get(el) !== seq) return

  injectProductLinkCards(el, {
    products: store.getters['products/allItems'] || [],
    categories: store.getters['productCategories/enabledItems'] || [],
    locale: store.state.locale?.current,
  })
  enhanceHotspotDeviceCards(el, {
    products: store.getters['products/allItems'] || [],
    categories: store.getters['productCategories/enabledItems'] || [],
    locale: store.state.locale?.current,
  })
  promoteInlineStyles(el)
  initHotspotDeviceCarousels(el)
  scheduleScrollToHotspotHash(el)
}

/** v-csp-html：等价于 v-html，并在写入后提升 style + 注入设备链接卡片 */
export default {
  mounted(el, binding) {
    applyHtml(el, binding.value, binding.instance)
  },
  updated(el, binding) {
    if (binding.value === binding.oldValue) return
    applyHtml(el, binding.value, binding.instance)
  },
}
